import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/contexts/I18nContext';

interface InstructorSlotDashboardProps {
  instructorId: string;
  availableSlots: number;
  isOwnProfile?: boolean;
}

export const InstructorSlotDashboard: React.FC<InstructorSlotDashboardProps> = ({
  instructorId,
  availableSlots,
  isOwnProfile = false
}) => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const handleClick = () => {
    navigate(`/instructor-slots/${instructorId}`);
  };

  return (
    <div 
      className="bg-[#2D2424] rounded-lg p-4 mb-6 cursor-pointer hover:bg-[#332222] transition-colors"
      onClick={handleClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center mt-0.5">
            <Calendar className="w-4 h-4 text-white" />
          </div>
          <div>
            <h3 className="text-white font-bold text-sm leading-tight">
              {isOwnProfile 
                ? t('profile.my_available_class_slots')
                : t('profile.schedule_private_classes')
              }
            </h3>
            <p className="text-gray-300 text-[10px] font-light leading-tight mt-1">
              {availableSlots} {t('profile.class_slots_available_this_week')}
            </p>
          </div>
        </div>
        <ArrowRight className="w-5 h-5 text-gray-400" />
      </div>
    </div>
  );
};
